// extracted by mini-css-extract-plugin
module.exports = {"list":"list--kZI0j","item":"item--w-orb","selected":"selected--swyjr","block":"block--8C24i","relationbtn":"relationbtn--hVrMk","header":"header--YeVRI","section":"section--QuCEi","section__blocks":"section__blocks--96p1K","uihidden":"uihidden--wr-ZP","uivisible":"uivisible--OuhVO"};
    if(module.hot) {
      // 1653630376998
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  